var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.151H6.01M10 8.151H10.01M14 8.151H14.01M19 13.151C19 13.6814 18.7893 14.1901 18.4142 14.5652C18.0391 14.9403 17.5304 15.151 17 15.151H5L1 19.151V3.151C1 2.62057 1.21071 2.11186 1.58579 1.73679C1.96086 1.36171 2.46957 1.151 3 1.151H17C17.5304 1.151 18.0391 1.36171 18.4142 1.73679C18.7893 2.11186 19 2.62057 19 3.151V13.151Z",
    stroke: "#FFFDFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/ChatIcon.c253c20f58d58b594d6f7d1c1efc067f.svg";
export { ForwardRef as ReactComponent };